(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/models/new-coupon.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/models/new-coupon.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.tipset.models.NewCoupon = Backbone.Model.extend({
    initialize: function() {
      this.listenTo(svs.tipset.models.systems, 'change', this.setSystem);
    },

    setSystem: function() {
      this.trigger('showUsystemBtn');
    }
  });
})(Backbone, _, svs);

 })(window);